export default __webpack_public_path__ + "static/media/807.abc0d731.png";